export const mileTypesTranslate = { 
  FIRST: "первая", 
  MIDDLE: "магистраль", 
  LAST: "последняя" 
};
